import React from 'react';
import './Button.css';
import { getButtonClasses } from './Button.helpers';

const Button = (props) => {
    const classes = getButtonClasses(props.type);
    return (
        <>
            {props.btnType === 'submit' ? (
                <button type='submit' className={classes} onClick={props.onClick} disabled={props.disabled} style={props.style}>
                    {props.children}
                </button>
            ) : (
                <button type='button' className={classes} onClick={props.onClick} disabled={props.disabled} style={props.style}>
                    {props.children}
                </button>
            )}
        </>
    );
};

export default Button;
